import { Container } from './styled';
export function CommentBubble(props) {
    const { children, direction } = props;
    return <Container $direction={direction}>{children}</Container>;
}
